import { CircularProgress, Grid } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { sendCustomEmail } from 'queries/emailQueries';
import { userInfo } from 'reducers/user-info/slice';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import Button from '../../components/atoms/button';
import CustomSelect from '../../components/atoms/custom-select';
import { APIHeader } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  LocalSiteButtons,
  OwnerlscValue,
  RMdepartmentLabel,
  SiteReviewValue,
  TrackingInfoGrid,
  boldFont,
  homeButtonComponent,
  pageGrid,
  resourceDropdown,
  siteDetails,
  siteDetailsGrid,
  titleName,
} from '../../styles';
import { findUnique, getURL, isEmptyObject } from '../../utils';

const ResourceModification = props => {
  const {
    apiConfig,
    resourceModificationData = [],
    pecrData = {},
    userInfoData = {},
    errorInAPI,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const origin = getURL();

  const { mutate: sendCustomEmailMutation } = useMutation({
    mutationFn: sendCustomEmail,
    onError: error => {
      console.error('Error sending email:', error);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });

  const pecrDetails =
    resourceModificationData.length > 0 &&
    resourceModificationData[0] &&
    resourceModificationData[0][0];
  const siteReviewDetails =
    resourceModificationData.length > 0 &&
    resourceModificationData[1] &&
    resourceModificationData[1][0];
  const deptDetails =
    resourceModificationData.length > 0 && resourceModificationData[2];
  const currentStatus = Number(
    resourceModificationData.length > 0 &&
      resourceModificationData[3] &&
      resourceModificationData[3][0] &&
      resourceModificationData[3][0].CurrentStatus
  );
  const filteredDeptDetails =
    deptDetails.length > 0 &&
    findUnique(deptDetails, key => key.Ref.replace(/[^a-z]/gi, ''));

  const [siteCoordinators, setSiteCoordinators] = useState([]);
  const [selectedSiteCoordinator, setSelectedSiteCoordinator] = useState({
    label: siteReviewDetails.SiteCoordinator || '',
    value: siteReviewDetails.SiteCoordinatorID || 0,
  });
  const [owners, setOwners] = useState([]);
  const [selectedOwnerDetails, setSelectedOwnerDetails] = useState({
    label: siteReviewDetails.SiteOwner || '',
    value: siteReviewDetails.SiteOwnerID || 0,
  });
  const [selectedDeptLeadDetails, setSelectedDeptLeadDetails] = useState([]);
  const [deptLeadDetails, setDeptLeadDetails] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const onBackButtonClick = () => {
    window.history.back();
  };
  const getDeptLeadID = department => {
    const findDept = selectedDeptLeadDetails.find(dept => {
      return dept.Ref.toUpperCase() === department.toUpperCase();
    });
    return findDept ? findDept.DeptLeadID : 0;
  };
  const onSaveClick = () => {
    fetch(`${apiConfig.uiURL}api/UpdateResourceModification`, {
      headers: APIHeader(),
      method: 'PUT',
      body: JSON.stringify({
        pecrId: pecrData.pecrId,
        siteId: pecrData.siteId,
        UpdatedByUserID: userInfoData.userID,
        siteCoordinator: selectedSiteCoordinator.value,
        owner: selectedOwnerDetails.value,
        compliance: getDeptLeadID('compliance'),
        ehs: getDeptLeadID('ehs'),
        engineering1: getDeptLeadID('engineering1'),
        engineering2: getDeptLeadID('engineering2'),
        engineering3: getDeptLeadID('engineering3'),
        engineering4: getDeptLeadID('engineering4'),
        finance: getDeptLeadID('finance'),
        aftermarket: getDeptLeadID('aftermarket'),
        industrialprocess: getDeptLeadID('IndustrialProcess1'),
        industrialprocess2: getDeptLeadID('IndustrialProcess2'),
        industrialprocess3: getDeptLeadID('IndustrialProcess3'),
        industrialprocess4: getDeptLeadID('IndustrialProcess4'),
        literature: getDeptLeadID('literature'),
        logistics: getDeptLeadID('LogisticsSupplyChain1'),
        logistics2: getDeptLeadID('LogisticsSupplyChain2'),
        logistics3: getDeptLeadID('LogisticsSupplyChain3'),
        logistics4: getDeptLeadID('LogisticsSupplyChain4'),
        manufacturing1: getDeptLeadID('manufacturing1'),
        manufacturing2: getDeptLeadID('manufacturing2'),
        manufacturing3: getDeptLeadID('manufacturing3'),
        manufacturing4: getDeptLeadID('manufacturing4'),
        marketing: getDeptLeadID('marketing'),
        purchasing: getDeptLeadID('purchasing'),
        quality1: getDeptLeadID('quality1'),
        quality2: getDeptLeadID('quality2'),
        quality3: getDeptLeadID('quality3'),
        quality4: getDeptLeadID('quality4'),
        sales1: getDeptLeadID('Sales1'),
        sales2: getDeptLeadID('Sales2'),
        sales3: getDeptLeadID('Sales3'),
        sales4: getDeptLeadID('Sales4'),
        salestools: getDeptLeadID('salestools'),
      }),
    })
      .then(async response => {
        Number(response.status) === 200 && onBackButtonClick();
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //send email to modified Site Coordinator only if Site Coordinator is not modified then Email will be not getting sent
    if (
      Number(selectedSiteCoordinator.value) !==
      Number(siteReviewDetails.SiteCoordinatorID)
    ) {
      return fetch(`${apiConfig.uiURL}api/sendEmail`, {
        headers: APIHeader(),
        method: 'POST',
        body: JSON.stringify({
          toWhome: 'BackUp Site Coordinator',
          PecrId: pecrData.pecrId,
          role: 'Site Coordinator',
          toAddress: selectedSiteCoordinator.Email
            ? selectedSiteCoordinator.Email
            : '',
          fromAddress: 'PECR@carrier.com',
          loginUserEmail: userInfoData.userEmail,
          Title: pecrDetails.Title ? pecrDetails.Title : '',
          type: 'assignEmail',
          URL: `${origin}${pecrData.url}`,
          summaryURL: `${origin}TrackingFile?id=${pecrData.pecrId}`,
        }),
      }).catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    }
    //send email to modified Owner only if Owner is not modified then Email will be not getting sent
    if (
      Number(selectedOwnerDetails.value) !==
      Number(siteReviewDetails.SiteOwnerID)
    ) {
      sendCustomEmailMutation({
        toAddress: [
          selectedOwnerDetails.email ? selectedOwnerDetails.email : '',
          siteReviewDetails.SiteOwnerEmail
            ? siteReviewDetails.SiteOwnerEmail
            : '',
        ],
        fromAddress: 'PECR@carrier.com',
        subject: `Site Owner Reassigned on PECR ${pecrData.pecrId} With Title: ${pecrDetails.Title}`,
        body: 'The Site Owner has been reassigned. Please check the details in the Tracking File.',
        link: `${origin}TrackingFile?id=${pecrData.pecrId}`,
      });
      // return fetch(`${apiConfig.uiURL}api/sendEmail`, {
      //   headers: APIHeader(),
      //   method: 'POST',
      //   body: JSON.stringify({
      //     toWhome: 'BackUp Site Coordinator',
      //     PecrId: pecrData.pecrId,
      //     role: 'Site Owner',
      //     toAddress: selectedOwnerDetails.email
      //       ? selectedOwnerDetails.email
      //       : '',
      //     fromAddress: 'PECR@carrier.com',
      //     loginUserEmail: userInfoData.userEmail,
      //     Title: pecrDetails.Title ? pecrDetails.Title : '',
      //     type: 'assignEmail',
      //     summaryURL: `${origin}TrackingFile?id=${pecrData.pecrId}`,
      //     URL: `${origin}${pecrData.url}`,
      //   }),
      // }).catch(() => {
      //   dispatch(
      //     errorNotification({
      //       hasErrorOccured: true,
      //       message: t('error_message'),
      //     })
      //   );
      // });
    }
    //get departmen lead details for only those departmen whose departmen lead has modified
    const changedDeptHead = selectedDeptLeadDetails.filter(obj1 =>
      deptDetails.some(
        obj2 =>
          obj1.DeptID === obj2.DeptID &&
          obj1.EIndex === obj2.EIndex &&
          obj1.DeptLeadID !== obj2.DeptLeadID
      )
    );
    //send email to modified departmen leads only
    changedDeptHead.length > 0 &&
      changedDeptHead.forEach(async item => {
        return fetch(`${apiConfig.uiURL}api/sendEmail`, {
          headers: APIHeader(),
          method: 'POST',
          body: JSON.stringify({
            toWhome: 'BackUp Site Coordinator',
            PecrId: pecrData.pecrId,
            role: 'Department Lead',
            toAddress: item.Email ? item.Email : '',
            fromAddress: 'PECR@carrier.com',
            loginUserEmail: userInfoData.userEmail,
            Title: pecrDetails.Title ? pecrDetails.Title : '',
            type: 'assignEmail',
            summaryURL: `${origin}TrackingFile?id=${pecrData.pecrId}`,
            URL: `${origin}${pecrData.url}${item.DeptID}/${item.EIndex}`,
          }),
        }).catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
      });
  };

  useEffect(() => {
    setSelectedDeptLeadDetails(deptDetails);
  }, [deptDetails]);

  useEffect(() => {
    if (!isEmptyObject(pecrData)) {
      //Fetch PECR Owners to display in Owner dropdown
      fetch(`${apiConfig.uiURL}api/PECROwner`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          SiteId: pecrData.siteId,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setOwners(data);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });

      //Fetch Site Coordinators to display in Site Coordinator dropdown
      fetch(`${apiConfig.uiURL}api/FetchSiteCoordinator`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          SiteId: pecrData.siteId,
        }),
      })
        .then(async response => {
          const data = await response.json();
          setSiteCoordinators(data);
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });

      //Fetch departmets' option for each department to display in Department dropdown
      filteredDeptDetails.length > 0 &&
        filteredDeptDetails.map(async item => {
          const response = await fetch(
            `${apiConfig.uiURL}api/SCDepartmentsPOPUP`,
            {
              method: 'POST',
              headers: APIHeader(),
              body: JSON.stringify({
                pecrId: item.PECR_ID,
                SiteId: item.SiteID,
                DepartmentID: item.DeptID,
              }),
            }
          ).catch(() => {
            dispatch(
              errorNotification({
                hasErrorOccured: true,
                message: t('error_message'),
              })
            );
          });
          const data = await response.json();
          setDeptLeadDetails(prevState => [...prevState, data]);
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiConfig, pecrData]);

  //Returning options for Site Coordinator dropdown
  const siteCoordinatorOptions = siteCoordinators?.map(list => {
    return { label: `${list.Name}`, value: list.ID };
  });

  //Returning options for Owner dropdown
  const ownerOptions = owners?.map(list => {
    return { label: `${list.OwnerName}`, value: list.ID };
  });

  //Returning options for departmets' dropdown
  useEffect(() => {
    const options =
      deptLeadDetails.length > 0
        ? deptLeadDetails
            .map(list => {
              return list.map(dept => {
                return {
                  label: dept.OwnerName,
                  value: dept.ID,
                  DepartmentLead: dept.DepartmentLead,
                  FirstName: dept.FirstName,
                  LastName: dept.LastName,
                  Name: dept.Name,
                  SiteName: dept.SiteName,
                  Email: dept.Email,
                };
              });
            })
            .flat()
        : [];
    setDepartmentOptions(options);
  }, [deptLeadDetails]);

  //To handle the Site Coordinator dropdown onChange
  const handleSiteCoordinatorChange = option => {
    const findSiteCoordinator =
      siteCoordinators.length > 0 &&
      siteCoordinators.find(list => {
        return list.ID === option?.value;
      });
    setSelectedSiteCoordinator({
      label: findSiteCoordinator.Name ? findSiteCoordinator.Name : '',
      value: findSiteCoordinator.ID ? findSiteCoordinator.ID : '',
      email: findSiteCoordinator.Email ? findSiteCoordinator.Email : '',
      changed: true,
    });
  };

  //To handle the owner dropdown onChange
  const handleOwnerChange = option => {
    const ownerDetails =
      owners.length > 0 &&
      owners.find(list => {
        return list.ID === option?.value;
      });
    setSelectedOwnerDetails({
      label: ownerDetails.OwnerName ? ownerDetails.OwnerName : '',
      value: ownerDetails.ID ? ownerDetails.ID : '',
      email: ownerDetails.Email ? ownerDetails.Email : '',
      changed: true,
    });
  };

  //To handle the department dropdown onChange
  const handleDepartmentOwnerChange = (option, index) => {
    setSelectedDeptLeadDetails(prevState =>
      prevState.map((obj, i) =>
        i === index
          ? {
              ...obj,
              DeptLead: option.label,
              DeptLeadID: option.value,
              Email: option.Email,
            }
          : obj
      )
    );
  };

  return errorInAPI.hasErrorOccured ? (
    <ErrorAlert message={errorInAPI.message} />
  ) : resourceModificationData.length > 0 ? (
    <Grid style={pageGrid}>
      <Grid>
        <h4 style={titleName}>{t('PECR_Site_Resource_Modification')}</h4>
      </Grid>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid style={TrackingInfoGrid} item xs={2} sm={4} md={4}>
          <Grid style={boldFont}>{`${t('Title')}:`}</Grid>
          <Grid style={OwnerlscValue}>{pecrDetails.Title}</Grid>
        </Grid>
        <Grid style={TrackingInfoGrid} item xs={2} sm={4} md={4}>
          <Grid style={boldFont}>{`${t('Creator')}:`}</Grid>
          <Grid style={SiteReviewValue}>{pecrDetails.CreatorName}</Grid>
        </Grid>
        <Grid style={TrackingInfoGrid} item xs={2} sm={4} md={4}>
          <Grid style={boldFont}>{`${t('Product_Family')}:`}</Grid>
          <Grid style={SiteReviewValue} width={1000}>
            {pecrDetails.ProductFamily}
          </Grid>
        </Grid>
        <Grid style={TrackingInfoGrid} item xs={2} sm={4} md={4}>
          <Grid style={boldFont}>{`${t('Description')}:`}</Grid>
          <Grid style={OwnerlscValue}>{pecrDetails.Description}</Grid>
        </Grid>
      </Grid>
      <Grid style={siteDetails}>
        <Grid style={TrackingInfoGrid}>
          <Grid style={boldFont}>{`${t('Site')}:`}</Grid>
          <Grid style={OwnerlscValue}> {pecrDetails.SiteName}</Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          columns={16}
          sx={{
            width: '70%',
            marginLeft: '20%',
            marginTop: '2%',
          }}
        >
          {(currentStatus === 1 ||
            currentStatus === 3 ||
            currentStatus === 5 ||
            currentStatus === 7 ||
            currentStatus === 13 ||
            currentStatus === 15 ||
            currentStatus === 16 ||
            currentStatus === 18 ||
            currentStatus === 21) && (
            <Grid item xs={8} style={siteDetailsGrid}>
              <Grid style={boldFont}>{`${t('Site_Coordinator')}:`}</Grid>
              <Grid style={OwnerlscValue}>
                <CustomSelect
                  name={'SiteCoordinator'}
                  id={'SiteCoordinator'}
                  options={siteCoordinatorOptions}
                  placeholder={t('Select_Site_coordinator')}
                  value={selectedSiteCoordinator}
                  onChange={handleSiteCoordinatorChange}
                />
              </Grid>
            </Grid>
          )}

          <div className="flex w-full flex-col">
            {userInfo.role !== 'Owner' && (
              <Grid item xs={8} style={siteDetailsGrid}>
                <Grid style={boldFont}>{`${t('Owner')}:`}</Grid>
                <Grid style={resourceDropdown}>
                  <CustomSelect
                    name={'SCowner'}
                    id={'SCowner'}
                    options={ownerOptions}
                    placeholder={t('Select_PECR_Owner')}
                    value={selectedOwnerDetails}
                    onChange={handleOwnerChange}
                  />
                </Grid>
              </Grid>
            )}
            {(currentStatus === 11 ||
              currentStatus === 12 ||
              currentStatus === 19 ||
              currentStatus === 20) && (
              <Grid item xs={8} style={siteDetailsGrid}>
                <Grid style={boldFont}>{t('Departments')}</Grid>
              </Grid>
            )}
          </div>
        </Grid>
        {(currentStatus === 11 ||
          currentStatus === 12 ||
          currentStatus === 19 ||
          currentStatus === 20) && (
          <Grid
            sx={{
              width: '40%',
              marginLeft: '20%',
              marginTop: '0',
            }}
          >
            {selectedDeptLeadDetails &&
              selectedDeptLeadDetails.length > 0 &&
              selectedDeptLeadDetails.map((item, index) => {
                const selectedDeptLead = {
                  label: item.DeptLead,
                  value: item.DeptLeadID,
                };
                return (
                  <Grid style={siteDetailsGrid} key={index} container>
                    <Grid style={RMdepartmentLabel}>
                      {item.Label
                        ? `${item.Department} (${item.Label}):`
                        : `${item.Department}:`}
                    </Grid>
                    <Grid item xs={10}>
                      <CustomSelect
                        name={'DepartmentOwner'}
                        id={'DepartmentOwner'}
                        options={departmentOptions.filter(department => {
                          return (
                            department.Name.replace(/[^a-z]/gi, '') ===
                            item.Department.replace(/[^a-z]/gi, '')
                          );
                        })}
                        placeholder={t('Select_Department_Owner')}
                        value={selectedDeptLead}
                        onChange={event =>
                          handleDepartmentOwnerChange(event, index)
                        }
                      />
                    </Grid>
                  </Grid>
                );
              })}
          </Grid>
        )}
      </Grid>
      <Grid style={LocalSiteButtons}>
        <Button title={t('Back')} onClick={onBackButtonClick} />
        <Button
          title={t('Save_Resource_Modifications')}
          onClick={onSaveClick}
        />
      </Grid>
    </Grid>
  ) : (
    <Grid style={homeButtonComponent}>
      <CircularProgress />
    </Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    resourceModificationData: state.resourceModificationData,
    pecrData: state.pecrURLData,
    userInfoData: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(ResourceModification);
